import Modal from "react-native-modal";
import { StyleSheet, View, Text, TouchableOpacity } from 'react-native';
import FontAwesome from "@expo/vector-icons/FontAwesome";

// Shown from the "create post" FAB when the user tries to create a bar post
// without having a business associated with their account.
export default function BusinessRequiredModal({ visible, dismiss, hasSavedUserId, onCreateAccount, onAddBusiness }) {

  return (
    <Modal
      isVisible={visible}
      hasBackdrop={true}
      backdropColor="#EBBB40"
      backdropOpacity={0.6}
      onBackdropPress={dismiss}
    >
      <View style={styles.container}>
        <FontAwesome
          name="building-o"
          size={32}
          color="#674FE0"
          style={styles.icon}
        />

        <Text style={styles.title}>Business Account Required</Text>

        <Text style={styles.message}>
          To make a bar post, you must have created an account and added a business to it in the Profile page.
        </Text>

        {!hasSavedUserId &&
          <TouchableOpacity style={styles.primaryButton} onPress={onCreateAccount}>
            <Text style={styles.primaryButtonText}>Sign In / Create Account</Text>
          </TouchableOpacity>
        }

        {hasSavedUserId &&
          <TouchableOpacity style={styles.primaryButton} onPress={onAddBusiness}>
            <Text style={styles.primaryButtonText}>Add Business to Account</Text>
          </TouchableOpacity>
        }

        <TouchableOpacity style={styles.closeButton} onPress={dismiss}>
          <Text style={styles.closeButtonText}>Close</Text>
        </TouchableOpacity>
      </View>
    </Modal>
  );
}


const styles = StyleSheet.create({
  container: {
    width: 280,
    backgroundColor: 'white',
    alignSelf: 'center',
    borderRadius: 12,
    padding: 20,
    alignItems: 'center',
  },
  icon: {
    marginBottom: 10,
  },
  title: {
    fontSize: 18,
    fontWeight: '700',
    color: '#25292e',
    marginBottom: 10,
    textAlign: 'center',
  },
  message: {
    fontSize: 14,
    color: '#555',
    textAlign: 'center',
    marginBottom: 20,
    lineHeight: 20,
  },
  primaryButton: {
    backgroundColor: '#674FE0',
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 20,
    width: '100%',
    alignItems: 'center',
    marginBottom: 10,
  },
  primaryButtonText: {
    color: '#fff',
    fontSize: 15,
    fontWeight: '600',
  },
  closeButton: {
    paddingVertical: 8,
    paddingHorizontal: 20,
  },
  closeButtonText: {
    color: '#674FE0',
    fontSize: 14,
    fontWeight: '500',
  },
});
